export const formatPersistedQuery = (query = {}) => {

  return Object.keys(query).reduce((a,k) => {
    a = {...a, ...query[k] }
    return a;
  }, {});
}